"use strict";import{css as e}from"@spectrum-web-components/base";const s=e`
:host([disabled]) ::slotted([slot=trigger]){pointer-events:none}slot[name=longpress-describedby-descriptor]{display:none}
`;export default s;
//# sourceMappingURL=overlay-trigger.css.js.map
